<script lang="ts">
export default {
  name: 'KkSearchQueryTd'
}
</script>
<script lang="ts" setup>
import { KkBadge } from 'src/biz_spa/components/base'
import { KkLabelBrandedBadge } from '../../../analysis'
import { toNumberLocaleString } from '../../../../modules/localeString'
import type { HeadIdKind } from '../../types'
import { useI18n } from 'vue-i18n'

export interface Props {
  headId: HeadIdKind
  item: boolean | string | number | null
  activateClickItemFunction?: boolean
}
const props = defineProps<Props>()
const emit = defineEmits(['click-item'])

const { t } = useI18n()
</script>

<template>
  <!-- 指名/間接ラベルの場合 -->
  <div v-if="headId === 'searchKeywordLabelBranded'" :class="$style.label">
    <template v-if="item === null">-</template>
    <KkLabelBrandedBadge v-else :kind="item ? t('models.analysis.searchQueriesDataType.searchKeywordLabelBranded.branded') : t('models.analysis.searchQueriesDataType.searchKeywordLabelBranded.nonBranded')" />
  </div>
  <!-- 注目ラベルの場合 -->
  <div v-else-if="headId === 'searchKeywordLabelSelected'" :class="$style.label">
    <template v-if="!item">-</template>
    <KkBadge v-else :text="t('models.analysis.searchQueriesDataType.searchKeywordLabelSelected.name')" text-color="#3A3B3F" background-color="#E3E3E3" />
  </div>
  <!-- 言語の場合 -->
  <div v-else-if="typeof props.item === 'string'">{{ props.item }}</div>
  <!-- QSCAの場合 -->
  <button v-else-if="activateClickItemFunction" :class="$style.activateClickItem" @click="emit('click-item')">{{ toNumberLocaleString(props.item) }}</button>
  <!-- その他の場合 -->
  <div v-else>{{ toNumberLocaleString(props.item) }}</div>
</template>

<style lang="scss" module>
.label {
  display: flex;
  justify-content: center;
}

.activateClickItem {
  text-decoration: underline;
}
</style>
